import { AccountUsersChangePasswordRequest } from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useChangeAccountUserPassword from '@/hooks/useApi/useChangeAccountUserPassword';
import ChangeUserPasswordForm from './ChangeUserPasswordForm';
import ChangeUserPasswordContext, { ChangeUserPasswordCtx } from './ChangeUserPasswordContext';
import ChangeUserPasswordDialogue from './ChangeUserPasswordDialogue';
import { ChangePasswordDialogueHandler, DialogueHandlerProps } from '../types';

type FC = FunctionComponent;

const ChangeUserPasswordContainer: FC = () => {
  const history = useHistory();
  const [ChangeUserPasswordError, setChangeUserPasswordError] = useState('');
  const [showChangeUserPasswordErrorAlert, setShowChangeUserPasswordErrorAlert] = useState(false);
  const [showChangeUserPasswordSuccessAlert, setShowChangeUserPasswordSuccessAlert] = useState(false);
  const [shouldChangeUserPassword, setShouldChangeUserPassword] = useState(false);
  const { response, changePassword } = useChangeAccountUserPassword();
  const { emailAddress } = useParams<{ emailAddress: string }>();

  const ChangeUserPassword: ChangeUserPasswordCtx = {
    showChangeUserPasswordSuccessAlert,
    showChangeUserPasswordErrorAlert,
    ChangeUserPasswordError,
  };

  const handlers = {
    handleDialogue: (handlerProps: DialogueHandlerProps<ChangePasswordDialogueHandler>) => {
      const { type, state, action = 'default' } = handlerProps;

      const dialogueHandlers: ChangePasswordDialogueHandler = {
        change: {
          success: {
            default: () => {
              setShowChangeUserPasswordSuccessAlert(false);
              history.push('/users');
            },
          },
          fail: {
            default: () => {
              setShowChangeUserPasswordErrorAlert(false);
              setChangeUserPasswordError('');
            },
          },
        },
      };
      const dialogueState = dialogueHandlers[type][state];
      const handler = dialogueState[action] || dialogueState.default;

      handler();
    },
    onChangeUserPassword: (values: AccountUsersChangePasswordRequest) => {
      setShouldChangeUserPassword(true);
      const UserChangePasswordRequest = { ...values };
      UserChangePasswordRequest.EmailAddress = emailAddress;
      changePassword(UserChangePasswordRequest);
    },
  };

  useEffect(() => {
    if (shouldChangeUserPassword) {
      setShouldChangeUserPassword(false);
      if (response) {
        const { Success, ErrorMessage } = response;
        if (Success === true) {
          setShowChangeUserPasswordSuccessAlert(true);
        } else {
          setChangeUserPasswordError(ErrorMessage);
          setShowChangeUserPasswordErrorAlert(true);
        }
      }
    }
  }, [response]);

  return (
    <ChangeUserPasswordContext.Provider value={ChangeUserPassword}>
      <ChangeUserPasswordForm handlers={handlers} email={emailAddress} />
      <ChangeUserPasswordDialogue handleDialogue={handlers.handleDialogue} />
    </ChangeUserPasswordContext.Provider>
  );
};

export default ChangeUserPasswordContainer;
